import api from '@/store/api'
import { rawSubscriptionPlanForm } from '@/utils/meta.js'
import { getField, updateField } from 'vuex-map-fields'

const state = {
	subscriberPlans: {
		data: [],
		last_page: 0,
		to: 0,
		from: 0,
		total: 0
	},
	filter: {
		keyword: '',
		page: 1,
		count: 10,
		sort_by: '',
		theme_filter: []
	},
	form: {
		name: '',
		price: '',
		billing_cycle: '',
		duration: '',
		is_discounted: 0,
		discount: '',
		currency: 'usd',
		discount_duration_to: null,
		discount_duration_from: null
	},
	errors: {
		name: '',
		price: '',
		billing_cycle: '',
		duration: '',
		is_discounted: ''
	},
	isLoading: false
}

const mutations = {
	updateField,
	setPlan (state, payload) {
		const dateFrom = new Date(payload.discount_duration_from)
		const dateTo = new Date(payload.discount_duration_to)
		state.form = {
			...payload,
			duration: payload.duration !== 'null' ? payload.duration : '',
			discount: payload.discount !== 'null' ? payload.discount : '',
			billing_cycle: payload.billing_cycle.charAt(0).toUpperCase() + payload.billing_cycle.slice(1),
			discount_duration_from: isNaN(dateFrom.getTime()) ? null : dateFrom,
			discount_duration_to: isNaN(dateTo.getTime()) ? null : dateTo
		}
	},
	clearPlan (state) {
		state.form = { ...rawSubscriptionPlanForm }
	}
}

const actions = {
	async list ({ state }, payload) {
		state.isLoading = true
		const { data, status } = await api('get', `subscription-list${payload}`)

		if (status) {
			state.subscriberPlans.data = data.data.data
			state.filter.page = data.data.current_page
			state.subscriberPlans.last_page = data.data.last_page
			state.subscriberPlans.to = data.data.to
			state.subscriberPlans.from = data.data.from
			state.subscriberPlans.total = data.data.total
			state.filter.count = Number(data.data.per_page)
		} else {
			state.songs = []
		}
		state.isLoading = false
	},

	async create ({ state, dispatch }, { form, callback }) {
		state.isLoading = true
		const { data, status } = await api('post', 'add-subscription', form)
		console.log(status, data)
		if (status) {
			dispatch('toggleBanner', {
				message: 'Subscription Plan has been successfully created.',
				type: 'success'
			}, { root: true })
			callback()
			state.form = {
				name: '',
				price: '',
				billing_cycle: '',
				duration: '',
				is_discounted: 0,
				discount: '',
				currency: 'usd'
			}
		} else {
			if (data.message) {
				state.errors.name = data.message
			} else {
				state.errors = Object.keys(data.errors).reduce((prev, curr) => {
					prev[curr] = data.errors[curr][0]
					return prev
				}, {})
			}
		}
		state.isLoading = false
	},
	async update ({ state, dispatch }, { form, callback }) {
		state.isLoading = true
		const { data, status } = await api('post', 'update-subscription', form)

		if (status) {
			dispatch('toggleBanner', {
				message: 'Subscription Plan has been successfully updated.',
				type: 'success'
			}, { root: true })
			callback()
			state.form = {
				name: '',
				price: '',
				billing_cycle: '',
				duration: '',
				is_discounted: 0,
				discount: '',
				currency: 'usd',
				discount_duration_to: null,
				discount_duration_from: null
			}
		} else {
			dispatch('toggleBanner', {
				message: data.message || 'Something went wrong.',
				type: 'error'
			}, { root: true })
		}
		state.isLoading = false
	},
	async view ({ state, commit, dispatch }, id) {
		state.isLoading = true
		const { data, status } = await api('get', `subscription-view?id=${id}`)

		if (status) {
			commit('setPlan', data.data)
		} else {
			dispatch('toggleBanner', {
				message: data.message || 'Something went wrong.',
				type: 'error'
			}, { root: true })
		}
		state.isLoading = false
	},
	clearPlan ({ commit }) {
		commit('clearPlan')
	}
}

const getters = {
	getField,
	subscriberPlansList: state => state.subscriberPlans,
	isLoading: state => state.isLoading
}

export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true
}
